export default "__VITE_ASSET__7gCFa$SI__"